import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
} from "@mui/material";
import SecondaryButton from "./secondaryButton";

const DataTable = ({ columns, data, name, handleMockTest }) => {
  return (
    <TableContainer
      component={Paper}
      sx={{ boxShadow: "none", borderRadius: 0 }}
    >
      <Table>
        <TableHead>
          <TableRow sx={{ backgroundColor: "rgba(240, 240, 251, 1)" }}>
            {columns.map((column) => (
              <TableCell
                key={column.id}
                align={column.align || "left"}
                sx={{
                  color: "rgba(63, 65, 209, 1)",
                  fontWeight: "600",
                  fontSize: "14px",
                  textTransform: "capitalize",
                  borderRight: "1px solid #E0E0E0",
                  borderLeft: "1px solid #E0E0E0",
                }}
              >
                {column.label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>

        <TableBody>
          {data.map((row, rowIndex) => (
            <TableRow key={rowIndex} hover>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align || "left"}
                  sx={{
                    color: "rgba(63, 65, 209, 1)",
                    fontSize: "14px",
                    borderRight: "1px solid #E0E0E0",
                    borderLeft: "1px solid #E0E0E0",
                  }}
                >
                  {column.id === "action" && name === "mocktest" ? (
                    <SecondaryButton onClick={handleMockTest}>
                      Take mock exam
                    </SecondaryButton>
                  ) : (
                    row[column.id]
                  )}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default DataTable;
